import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {GlobalObjectService} from '../../../../class/global-obj';
import {IFieldShema} from '@usteknoloji/noosgrid';

@Component({
    selector: 'noos-viewphoto',
    templateUrl: './viewphoto.component.html',
    styleUrls: ['./viewphoto.component.scss']
})
@NoosFormTypeService.register('viewPhoto')
export class ViewphotoComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter = false;

    formFieldStructure: IFieldShema[];
    formRecordData: any;

    photoLink = '';

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit() {
        this.formFieldStructure = GlobalObjectService.getVar('formFieldStructure_' + this.formId.toString());
        this.formRecordData = GlobalObjectService.getVar('formRecordData_' + this.formId.toString());
    }

    ngAfterViewInit(): void {
        const isR = this.formFieldStructure.filter(x => x.field_name === this.prop.name);
        if (isR.length > 0) {
            const field_alias = isR[0].field_alias;
            this.photoLink = this.formRecordData[field_alias];
        }
    }

}
